<template>
	<div class="bf">
		<div class="" style="padding-bottom: 80px;">
			<div class="bgfff mb20" v-for="(item,index) in list" :key="index">
				<swipe-cell v-if="!item.leave_approval">
					<div class="pt20 pb20 plr20">
						<div class="flex flex_between flex_items  mb20">
							<div class="flex flex_items">
								<div class="ca6 mr20">请假日期</div>
								<div class="l1">{{item.date}}{{item.time == 'afternoon' ? '下午' : item.time == 'forenoon' ? '上午' : ''}}</div>
							</div>
							<div :class="item.leave_approval ? 'main_color' : 'blue'">
								{{item.leave_approval ? '已批准' : '待审批'}}</div>
						</div>
						<div class="flex" style="align-items: flex-start;">
							<div class="ca6 mr20">请假事由</div>
							<div class="flex1">{{item.remark}}</div>
						</div>
					</div>
					<template #right>
						<button class="del-reply main_bg" @click="replyClose(item,index)">
							取消申请
						</button>
					</template>
				</swipe-cell>
				<div class="pt20 pb20 plr20" v-else>
					<div class="flex flex_between flex_items  mb20">
						<div class="flex flex_items">
							<div class="ca6 mr20">请假日期</div>
							<div class="l1">{{item.date}}{{item.time == 'afternoon' ? '下午' : item.time == 'forenoon' ? '上午' : ''}}</div>
						</div>
						<div :class="item.leave_approval ? 'main_color' : 'blue'">
							{{item.leave_approval ? '已批准' : '待审批'}}</div>
					</div>
					<div class="flex" style="align-items: flex-start;">
						<div class="ca6 mr20">请假事由</div>
						<div class="flex1">{{item.remark}}</div>
					</div>
				</div>
			</div>

			<div class="empty" v-if="list.length == 0">
				暂无数据
			</div>
		</div>
		<div class="bottom_btn" @click="goto">
			<div class="btn_contenbt">去请假</div>
		</div>
	</div>
</template>

<script>
	import {
		SwipeCell,
		Dialog
	} from "vant";
	export default {
		data() {
			return {
				list: [],
				id: ''
			}
		},
		components: {
			SwipeCell
		},
		methods: {
			getPageList() {
				this.api.signLogs({
					is_leave: 1
				}, this.id).then(res => {
					this.list = res.data
				})
			},
			goto() {
				this.$router.push({
					path: '/leaveForm',
					query: {
						id: this.id
					}
				});
			},
			replyClose(item) {
				Dialog.confirm({
						title: '取消申请',
						message: '是否要取消此次申请？',
					})
					.then(() => {
						this.api.userUnleave({
							date: item.date,
							time:item.time
						}, this.id).then(res => {
							this.Toast('取消成功')
							this.getPageList()
						})
					})
					.catch(() => {
						// on cancel
					});
			}
		},
		created() {
			this.id = this.$route.query.id;
			this.getPageList()
		}
	}
</script>

<style scoped="scoped">
	.del-reply {
		width: 50px;
		height: 100%;
		border: none;
		color: #fff;

		i {
			color: #ffffff;
		}
	}
</style>
